import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class EnergiemonitorCanActivateGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (environment.featureEnergieMonitorV2Enabled && route.url[0]?.path.toLowerCase() === 'energiemonitor') {
      this.router.navigate(['/energiemonitorv2'], { queryParams: route.queryParams });
      return false;
    } else if (!environment.featureEnergieMonitorV2Enabled && route.url[0]?.path.toLowerCase() === 'energiemonitorv2') {
      this.router.navigate(['/energiemonitor'], { queryParams: route.queryParams });
      return false;
    }
    return true;
  }
}
